// eBL term clauses (cross-backend → admin-corev2). Mirrors admin-ui termClause.js.
import { adminRequest } from './client.js';

const api = {
	getTermClause: (id) => adminRequest('GET', `/termClause/${id}`),

	getAllTermClause: (params = {}) => {
		// The hook calls this with FLAT sort params ({...sort, ...}) where sort = {key, direction}
		// — matching admin-ui's service. Read key/direction directly, NOT a nested sortConfig
		// (that was always undefined → the sort column was ignored and defaulted to modified/desc).
		const { orgId, page, pageSize, key, direction } = params;
		const qs = new URLSearchParams({
			...(orgId ? { orgId } : {}),
			page: page || 1,
			count: pageSize || 10,
			sortBy: key || 'modified',
			direction: direction || 'desc',
		}).toString();
		return adminRequest('GET', `/termClause?${qs}`);
	},

	deleteTermClause: (id) => adminRequest('DELETE', `/termClause/${id}`),
	updateTermClauseName: (id, params) => adminRequest('PUT', `/termClause/rename/${id}`, params),
	createTermClause: (params) => adminRequest('POST', '/termClause', params),
	updateTermClause: (id, params) => adminRequest('PUT', `/termClause/${id}`, params),
};

export default api;
